/*** IMPORTS FROM imports-loader ***/
var global = window;

import React from 'react';
export default React.createContext(null);
